import React from 'react'

function DatePicker() {
    return <div className="knsl-datepicker-place"></div>;
}

export default DatePicker